// src/components/ads/InContentAd.tsx
import React from 'react';
import AdBanner from './AdBanner';

/**
 * 본문 중간 반응형 디스플레이 광고.
 *
 * 모든 페이지 공통으로 **본문 중간에 한 번만** 배치합니다.
 * (PC·모바일 모두 컨테이너 폭에 맞춰 늘어나는 반응형 단위이며,
 *  세로가 긴 지면에서는 애드센스가 수직형 크리에이티브를 선택합니다)
 *
 * 페이지에 이 컴포넌트를 두 번 이상 넣지 마세요.
 */
const InContentAd: React.FC = () => (
    <AdBanner slot="inArticle" format="auto" responsive className="gh-ad--incontent" />
);

export default InContentAd;
